import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hot/image/hot-title.png'
import _imports_1 from '@/assets/hot/image/question.png'


const _withScopeId = n => (_pushScopeId("data-v-67dfd40c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"126.1px","height":"32.5px"},
  alt: "九方热榜"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"14px","height":"14px"},
  alt: "信息"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rule-content",
  style: {"max-height":"60vh","overflow-y":"auto","padding":"0 10px"}
}, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"text-align":"center","font-weight":"bold","font-size":"18px","margin-bottom":"20px"} }, "九方热榜规则说明"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"15px"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":"5px"} }, "1. 榜单介绍"),
    /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"1.5","color":"#333"} }, " 九方智投热榜根据个股的交易数据、涨幅数据、市场舆情、用户关注等4大维度进行综合计算，评估个股热度，并进行实时榜单排名。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"15px"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":"5px"} }, "2. 排序规则"),
    /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"1.5","color":"#333","margin-bottom":"10px"} }, [
      /*#__PURE__*/_createTextVNode(" 九方热榜算法基于用户真实行为计算出热度自动排序进行展示，热股榜选取热度排名最高的100名进行展示。热度计算公式："),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "热度=交易数据热度+涨幅数据热度+市场舆情热度+用户关注热度")
    ]),
    /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"1.5","color":"#333"} }, [
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","margin-bottom":"4px"} }, [
        /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","margin-right":"5px"} }, "●"),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "交易数据热度："),
          /*#__PURE__*/_createTextVNode("通过对个股成交额、换手率等数据进行计算，反映个股交投活跃程度。")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","margin-bottom":"4px"} }, [
        /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","margin-right":"5px"} }, "●"),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "涨幅数据热度："),
          /*#__PURE__*/_createTextVNode("通过对个股阶段涨跌幅的综合计算，反映个股走势强弱程度。")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","margin-bottom":"4px"} }, [
        /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","margin-right":"5px"} }, "●"),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "市场舆情热度："),
          /*#__PURE__*/_createTextVNode("通过对个股相关资讯等数据监控计算，反映个股舆情曝光程度。")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","margin-bottom":"4px"} }, [
        /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","margin-right":"5px"} }, "●"),
        /*#__PURE__*/_createElementVNode("span", null, [
          /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "用户关注热度："),
          /*#__PURE__*/_createTextVNode("通过对用户在个股行情页的访问情况计算，反映用户对个股的关注程度。")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"15px"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":"5px"} }, "3. 更新规则"),
    /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"1.5","color":"#333"} }, " 热股榜排名每10分钟更新一次，以确保榜单的实时性和准确性。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"15px"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":"5px"} }, "4. 榜单规范"),
    /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"1.5","color":"#333"} }, " 九方智投致力于维护一个健康、公正的榜单环境，为用户提供真实、有价值的市场信息，严厉打击通过热榜谋取不正当流量和获取不正当商业利益等行为，欢迎广大用户和社会的监督举报，平台将严肃处理相关违规行为。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"15px"} }, [
    /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","margin-bottom":"5px"} }, "5. 免责声明"),
    /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"1.5","color":"#333"} }, " 九方智投发布此信息的目的在于传播更多信息，与本站立场无关。平台力求但不保证专题内容的准确性和完整性，请谨慎参考。本专题内任何信息不构成对任何人的投资建议，投资者应当自主决策，风险自担。 ")
  ])
], -1))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = {
  key: 0,
  class: "text-left"
}
const _hoisted_9 = {
  key: 0,
  style: {"margin-left":"8px"}
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("即时排名： 第 ")
const _hoisted_11 = { style: {"color":"red"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 名")
const _hoisted_13 = {
  key: 1,
  style: {"margin-left":"8px"}
}
const _hoisted_14 = {
  key: 1,
  class: "text-right"
}
const _hoisted_15 = { class: "box1" }
const _hoisted_16 = { class: "left" }
const _hoisted_17 = { class: "right" }
const _hoisted_18 = { class: "rightTitle" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 实时变动 ")
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { style: {"color":"red","margin-right":"2px"} }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("名 ")
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { style: {"color":"green","margin-right":"2px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("名 ")
const _hoisted_26 = {
  key: 2,
  style: {"margin-left":"2px"}
}
const _hoisted_27 = {
  key: 1,
  style: {"margin-left":"2px"}
}
const _hoisted_28 = {
  key: 0,
  id: "echarts1",
  class: "chart"
}
const _hoisted_29 = {
  key: 1,
  class: "chart"
}
const _hoisted_30 = {
  key: 2,
  class: "rightTitle"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 历史趋势 较昨日 ")
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 持平 ", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 名 ")
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " — ", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 3,
  class: "rightTitle"
}
const _hoisted_41 = {
  key: 4,
  id: "echarts2",
  class: "chart"
}
const _hoisted_42 = {
  key: 5,
  class: "chart"
}
const _hoisted_43 = { class: "box1" }
const _hoisted_44 = { class: "box1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Table = _resolveComponent("Table")!
  const _component_ArrowUpOutlined = _resolveComponent("ArrowUpOutlined")!
  const _component_ArrowDownOutlined = _resolveComponent("ArrowDownOutlined")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_tabs_pane = _resolveComponent("a-tabs-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    spinning: _ctx.hotListLoading,
    tip: "加载中...",
    wrapperClassName: "hot-spin-wrapper"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["wrapper hot-wrapper", { 'dark-theme': _ctx.theme === 'dark' }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("span", {
              class: "icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showExplain = true)),
              style: {"cursor":"pointer"}
            }, _hoisted_5),
            _createVNode(_component_a_modal, {
              visible: _ctx.showExplain,
              "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showExplain) = $event)),
              title: "榜单规则说明",
              footer: null,
              centered: true,
              width: 600,
              getContainer: _ctx.getContainer,
              transitionName: "",
              maskTransitionName: ""
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["visible", "getContainer"])
          ]),
          _createVNode(_component_Select, {
            onCheckStock: _ctx.checkStock,
            source: "hot",
            tags: _ctx.tags
          }, null, 8, ["onCheckStock", "tags"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "textInfo",
            style: _normalizeStyle({ color: _ctx.theme === 'dark' ? '#fff' : '#000' })
          }, [
            (_ctx.activeKey == 1 && _ctx.hotCur && _ctx.hotCur?.symbol)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.hotCur?.name) + " (" + _toDisplayString(_ctx.hotCur?.symbol) + ")", 1),
                  (_ctx.hotCur?.index)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.hotCur?.index), 1),
                        _hoisted_12
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, "即时排名：—"))
                ]))
              : _createCommentVNode("", true),
            (_ctx.upTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, "更新时间:" + _toDisplayString(_ctx.upTime), 1))
              : _createCommentVNode("", true)
          ], 4),
          _createVNode(_component_a_tabs, {
            activeKey: _ctx.activeKey,
            "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeKey) = $event)),
            onTabClick: _ctx.tabClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs_pane, {
                key: "1",
                tab: "热股榜"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_Table, {
                        theme: _ctx.theme,
                        data: _ctx.tableData,
                        columns: _ctx.columns1,
                        bordered: false,
                        style: {"height":"calc(100vh - 300px)","width":"100%"},
                        pagination: false,
                        customRow: _ctx.customRow,
                        setRowClassName: _ctx.setRowClassName
                      }, null, 8, ["theme", "data", "columns", "customRow", "setRowClassName"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        (_ctx.hotCur && _ctx.hotCur.rankChange !== undefined)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.hotCur.rankChange > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                    _createElementVNode("span", _hoisted_21, [
                                      _createVNode(_component_ArrowUpOutlined),
                                      _createTextVNode(_toDisplayString(_ctx.hotCur.rankChange), 1)
                                    ]),
                                    _hoisted_22
                                  ]))
                                : (_ctx.hotCur.rankChange < 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                      _createElementVNode("span", _hoisted_24, [
                                        _createVNode(_component_ArrowDownOutlined),
                                        _createTextVNode(_toDisplayString(Math.abs(_ctx.hotCur.rankChange)), 1)
                                      ]),
                                      _hoisted_25
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_26, "持平"))
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_27, "—"))
                      ]),
                      (_ctx.hasChartData1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_Nodata, {
                              mode: "vertical",
                              customdesc: "暂无实时变动数据"
                            })
                          ])),
                      (_ctx.hotCur)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("span", null, [
                              _hoisted_31,
                              (_ctx.hotCur.hisRankChange === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_34))
                                : (_ctx.hotCur.hisRankChange)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                      _createElementVNode("span", {
                                        style: _normalizeStyle(_ctx.hotCur.hisRankChange > 0 ? 'color:red' : _ctx.hotCur.hisRankChange < 0 ? 'color:green' : '')
                                      }, [
                                        (_ctx.hotCur.hisRankChange > 0)
                                          ? (_openBlock(), _createBlock(_component_ArrowUpOutlined, {
                                              key: 0,
                                              style: {"color":"red"}
                                            }))
                                          : (_ctx.hotCur.hisRankChange < 0)
                                            ? (_openBlock(), _createBlock(_component_ArrowDownOutlined, {
                                                key: 1,
                                                style: {"color":"green"}
                                              }))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(_ctx.hotCur.hisRankChange), 1)
                                      ], 4),
                                      _hoisted_36
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_37, _hoisted_39))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_40, "历史趋势")),
                      (_ctx.hasChartData2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41))
                        : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createVNode(_component_Nodata, {
                              mode: "vertical",
                              customdesc: "暂无历史趋势数据",
                              pagetheme: String(_ctx.theme)
                            }, null, 8, ["pagetheme"])
                          ]))
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tabs_pane, {
                key: "2",
                tab: "概念榜"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_Table, {
                      theme: _ctx.theme,
                      data: _ctx.tableData,
                      columns: _ctx.columns,
                      bordered: false,
                      pagination: false,
                      style: {"width":"100%","margin":"0 auto"},
                      customRow: _ctx.customRow2
                    }, null, 8, ["theme", "data", "columns", "customRow"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tabs_pane, {
                key: "3",
                tab: "行业榜"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_Table, {
                      theme: _ctx.theme,
                      data: _ctx.tableData,
                      columns: _ctx.columns,
                      bordered: false,
                      pagination: false,
                      style: {"width":"100%","margin":"0 auto"},
                      customRow: _ctx.customRow2
                    }, null, 8, ["theme", "data", "columns", "customRow"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey", "onTabClick"])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["spinning"]))
}